const baseURL = 'https://lenceria-gabrieles.kexe.mx/';

export default baseURL;
